// Function to decode JWT
export function decodeJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
            .join('')
    );
    return JSON.parse(jsonPayload);
}

export const getTokenExpiration = (token) => {
    try {
      const decodedToken = JSON.parse(atob(token.split(".")[1])); // Decode JWT
      return decodedToken.exp; // Return expiration timestamp
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };
export const startTokenRefresh = (tokenRefreshInterval) => {
    if (!tokenRefreshInterval.current) {
      tokenRefreshInterval.current = setInterval(() => {
        keycloakRef.current
          .updateToken(30)
          .then((refreshed) => {
            if (refreshed) {
            }
          })
          .catch(() => {
            console.warn("Token refresh failed, logging out");
            keycloakRef.current.logout();
          });
      }, 60000); // Check every 60 seconds
    }
  }
// Function to check if the token is expired
export function isTokenExpired(exp) {
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return exp < currentTime;
}

// Function to get roles starting with admin, editor, or viewer
export function getFilteredRoles(realmAccess) {
    const roles = realmAccess?.roles || [];
    return roles.filter(role => /^(admin|editor|viewer)/.test(role));
}

// Function to get the current logged-in user's roles from the stored Keycloak token
export function getCurrentUserRoles() {
    try {
        const token = localStorage.getItem("keycloak-token");
        if (!token) return [];
        const decodedToken = decodeJwt(token);
        return getFilteredRoles(decodedToken?.realm_access);
    } catch (error) {
        console.error("Error reading user roles from token:", error);
        return [];
    }
}

// Top-level routes.js `key`s a "viewer" realm-role user is allowed to see/reach.
// Everyone else is unaffected - see isRouteVisibleForUser below.
export const VIEWER_ALLOWED_ROUTE_KEYS = ["trafficMonitoring", "divider-0", "logout", "landingPage"];

// Function to check whether a top-level route/menu entry is visible for the given user.
// Only restricts users holding the "viewer" role to VIEWER_ALLOWED_ROUTE_KEYS; every
// other user sees no change at all.
export function isRouteVisibleForUser(route, userRoles) {
    if (!userRoles.includes("viewer")) return true;
    return VIEWER_ALLOWED_ROUTE_KEYS.includes(route.key);
}

// Function to check if the token is about to expire in the next 3 minutes
export function isTokenExpiringSoon(exp) {
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    const threeMinutesInSeconds = 3 * 60;
    return exp >= currentTime && exp <= currentTime + threeMinutesInSeconds;
}